// extracted by mini-css-extract-plugin
export default {"heading_text":"events_past_line_completed_heading_text__bSTH7"};